





























































































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  name: 'SettingsCars',
  data: () => ({
    tableData: [],
    modalEdit: false,
    modalDelete: false,
    places: [],
    validForm: false,
    search: '',
    terminal: {
      ID: 0,
      IDplaces: 0,
      placeName: '',
      groupName: '',
      name: '',
      displayName: '',
      UUID: '',
      created: '',
      lastCommunication: '',
      enabled: false,
      online: false,
    },
    headers: [
      { text: 'Jméno', value: 'name', width: '20%' },
      { text: 'Jméno pro zobrazení', value: 'displayName', width: '20%' },
      { text: 'Lokace', value: 'placeName', width: '20%' },
      { text: 'Skupina', value: 'groupName', width: '20%' },
      { text: 'Povolen', value: 'enabled', width: '10%' },
      { text: 'Aktivní', value: 'online', width: '10%' },
      { sortable: false, width: '48px' },
    ],
    rules: {
      required: (value: string) => !!value || 'Pole je povinné',
      number: (value: string) => {
        const pattern = /^\d+$/;
        return pattern.test(value) || 'Hodnota musí být číslo!!!';
      },
    },
  }),
  watch: {},
  mounted() {
    this.dataLoad();
    this.placesLoad();
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/terminal')
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      this.terminal = {
        ...this.terminal,
        ...((this.$options as Vue & { data: () => object }).data() as Vue & { terminal: object }).terminal,
      };
      this.modalEdit = true;
      this.$nextTick(function () {
        (this.$refs.terminalForm as Vue & { validate: () => boolean }).validate();
      });
    },
    dataSave() {
      if ((this.$refs.terminalForm as Vue & { validate: () => boolean }).validate() !== true) {
        this.$store.commit('globalMessage', 'Formulář obsahuje chyby!!!');
      } else {
        if (this.terminal.ID === 0) {
          axios
            .post('/api/v1/terminal', this.terminal)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put(`/api/v1/terminal/${this.terminal.ID}`, this.terminal)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/terminal/${this.terminal.ID}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalEdit = false;
      this.modalDelete = false;
    },
    placesLoad() {
      axios
        .get('/api/v1/place')
        .then((response) => {
          this.places = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
